export const purchasing = [
    {title:"Breeding Program", url:"about/breeding-program"},
    {title:"How to Buy", url:"about/how-to-buy"},
];